<div
	class="plc-progress-bar__value"
	[style.width]="percentageAsString"
	[@plcWidthIncrease]="{ value: ':enter', params: { size: percentage } }"
></div>
